import { render, staticRenderFns } from "./Violet.vue?vue&type=template&id=78f964b6&scoped=true&"
import script from "./Violet.vue?vue&type=script&lang=js&"
export * from "./Violet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f964b6",
  null
  
)

export default component.exports